import { Pipe, PipeTransform } from "@angular/core";
import { Produktionsstatus } from "~app/common/models/constants";

type ProduktionsstatusMap = {
    produktionEjPaborjad: string;
    produktionPagar: string;
    produktionAvslutad: string;
    slutrapporterad: string;
    produktionGodkand: string;
    makulerad: string;
};

const defaultMap: ProduktionsstatusMap = {
    produktionEjPaborjad: Produktionsstatus.ProduktionEjPaborjad,
    produktionPagar: Produktionsstatus.ProduktionPagar,
    produktionAvslutad: Produktionsstatus.ProduktionAvslutad,
    slutrapporterad: Produktionsstatus.Slutrapporterad,
    produktionGodkand: "Arbetsorder avslutad",
    makulerad: Produktionsstatus.Makulerad
};

const labelMap: ProduktionsstatusMap = {
    ...defaultMap,
    produktionAvslutad: "Produktion avslutad (slutrapport ej inskickad)",
    slutrapporterad: "Produktion slutrapporterad"
};

@Pipe({
    name: "produktionsstatus",
    standalone: true
})
export class ProduktionsstatusPipe implements PipeTransform {
    transform(value: string, useLabelMap = false): string {

        const mapper = useLabelMap ? labelMap : defaultMap;

        switch(value) {
            case Produktionsstatus.ProduktionEjPaborjad:
                return mapper.produktionEjPaborjad;
            case Produktionsstatus.ProduktionPagar:
                return mapper.produktionPagar;
            case Produktionsstatus.ProduktionAvslutad:
                return mapper.produktionAvslutad;
            case Produktionsstatus.Slutrapporterad:
                return mapper.slutrapporterad;
            case Produktionsstatus.ProduktionGodkand:
                return mapper.produktionGodkand;
            case Produktionsstatus.Makulerad:
                return mapper.makulerad;
        }

        return value;
    }
}
